const routesWithUniqueLayout = [
    '/pdv/venda',
    '/verificar-whatsapp',
];

export function routeHasUniqueLayout(pathname: string) {
    return routesWithUniqueLayout.some((route) => pathname.includes(route));
}